// IELLO p7 END OF THE GAME: "Each player then adds the value of all his
// cheques and all the coins he has not spent during the purchase phase. The
// richest player is declared the winner. In the event of a tie, the one to
// whom the most coins remain [wins]. If there is still a tie, victory is
// shared."

import { cardById } from './deck';

export const chequeTotalFor = (player) => (
  player.cheques.reduce((sum, id) => sum + cardById(id).value, 0)
);

/** A player's final wealth, in thousands. */
export const totalFor = (player) => chequeTotalFor(player) + player.coins;

/**
 * Ranks use competition numbering (1, 2, 2, 4) so two genuinely-tied players
 * read as tied rather than one of them silently losing on array order.
 */
export const scoreboard = (state) => {
  const rows = state.players.map((p) => ({
    id: p.id,
    name: p.name,
    seat: p.seat,
    cheques: [...p.cheques].sort((a, b) => cardById(b).value - cardById(a).value),
    chequeTotal: chequeTotalFor(p),
    coins: p.coins,
    total: totalFor(p),
  }));

  const ordered = [...rows].sort((a, b) => (
    b.total - a.total || b.coins - a.coins || a.seat - b.seat
  ));

  const ties = (a, b) => a.total === b.total && a.coins === b.coins;

  let rank = 0;
  return ordered.map((row, i) => {
    if (i === 0 || !ties(row, ordered[i - 1])) rank = i + 1;
    return { ...row, rank, isWinner: rank === 1 };
  });
};

export const winners = (state) => scoreboard(state).filter((row) => row.isWinner);
